// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.combobox-overlay {
    background: yellow;
}
.evi-combobox {
    background: inherit;
    background: var(--surface-a);
    padding: 0.5rem 0.5rem;
    border: 1px solid #ced4da;
    border: var(--border-thickness) solid var(--border-color);
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    appearance: none;
    border-top-left-radius: var(--border-radius-top-left);
    border-top-right-radius: var(--border-radius-top-right);
    border-bottom-left-radius: var(--border-radius-bottom-left);
    border-bottom-right-radius: var(--border-radius-bottom-right);
    position:absolute;
    display:flex;
    align-items:center;
}
.evi-combobox:hover {
    border-color: var(--primary-color);
    border-color: var(--border-hover-color);
}
.evi-combobox:focus {
    border-color: var(--primary-color);
    border-color: var(--border-hover-color);
}
.evi-combobox-focus {
    outline: 0 none;
    outline-offset: 0;
    box-shadow: 0 0 0 0.2rem var(--primary-color);
    box-shadow: 0 0 0 0.2rem var(--shadow-color);
    border-color: var(--primary-color);
    border-color: var(--border-focus-color);
}
.evi-combobox-selection {
    width:calc(100% - 20px);
}
.evi-combobox-item {
    padding-left: 10px;
    padding-right:10px;
}
.evi-combobox-item:hover {
    color: var(--foreground-text-hover-color);
    background-color: var(--primary-color);
}
.focus {
    color: var(--foreground-text-hover-color);
    background-color: var(--primary-color);
}
.evi-combobox-label {
    position: absolute;
    transition-duration: 0.2s;    
}
.float {
    top: -.75rem;
    font-size: 12px;
}

.evi-combobox .clear-selection {
    z-index: 2;
    font-size: 11pt;
}

.evi-combobox i.pi {
    position: initial;
    align-self: center;
    margin-top: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/combobox/combobox.control.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;IACzB,yDAAyD;IACzD,iFAAiF;IAGjF,gBAAgB;IAChB,qDAAqD;IACrD,uDAAuD;IACvD,2DAA2D;IAC3D,6DAA6D;IAC7D,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;AACA;IACI,kCAAkC;IAClC,uCAAuC;AAC3C;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,6CAA6C;IAC7C,4CAA4C;IAC5C,kCAAkC;IAClC,uCAAuC;AAC3C;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;AACA;IACI,yCAAyC;IACzC,sCAAsC;AAC1C;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".combobox-overlay {\n    background: yellow;\n}\n.evi-combobox {\n    background: inherit;\n    background: var(--surface-a);\n    padding: 0.5rem 0.5rem;\n    border: 1px solid #ced4da;\n    border: var(--border-thickness) solid var(--border-color);\n    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    border-top-left-radius: var(--border-radius-top-left);\n    border-top-right-radius: var(--border-radius-top-right);\n    border-bottom-left-radius: var(--border-radius-bottom-left);\n    border-bottom-right-radius: var(--border-radius-bottom-right);\n    position:absolute;\n    display:flex;\n    align-items:center;\n}\n.evi-combobox:hover {\n    border-color: var(--primary-color);\n    border-color: var(--border-hover-color);\n}\n.evi-combobox:focus {\n    border-color: var(--primary-color);\n    border-color: var(--border-hover-color);\n}\n.evi-combobox-focus {\n    outline: 0 none;\n    outline-offset: 0;\n    box-shadow: 0 0 0 0.2rem var(--primary-color);\n    box-shadow: 0 0 0 0.2rem var(--shadow-color);\n    border-color: var(--primary-color);\n    border-color: var(--border-focus-color);\n}\n.evi-combobox-selection {\n    width:calc(100% - 20px);\n}\n.evi-combobox-item {\n    padding-left: 10px;\n    padding-right:10px;\n}\n.evi-combobox-item:hover {\n    color: var(--foreground-text-hover-color);\n    background-color: var(--primary-color);\n}\n.focus {\n    color: var(--foreground-text-hover-color);\n    background-color: var(--primary-color);\n}\n.evi-combobox-label {\n    position: absolute;\n    transition-duration: 0.2s;    \n}\n.float {\n    top: -.75rem;\n    font-size: 12px;\n}\n\n.evi-combobox .clear-selection {\n    z-index: 2;\n    font-size: 11pt;\n}\n\n.evi-combobox i.pi {\n    position: initial;\n    align-self: center;\n    margin-top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
